var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.22529C11.0055 1.80586 11.842 2.63898 12.4265 3.64216C13.0111 4.64534 13.3236 5.78381 13.333 6.94485C13.3423 8.1059 13.0483 9.24926 12.48 10.2618C11.9117 11.2743 11.0888 12.1208 10.0928 12.7175C9.09683 13.3142 7.96224 13.6405 6.8014 13.664C5.64055 13.6875 4.4937 13.4074 3.47437 12.8515C2.45504 12.2955 1.59858 11.483 0.989778 10.4943C0.380975 9.50563 0.0409395 8.3751 0.00333341 7.21463L0 6.99863L0.00333341 6.78263C0.0406688 5.63129 0.375698 4.50927 0.97576 3.52595C1.57582 2.54264 2.42044 1.73159 3.42726 1.17188C4.43409 0.612168 5.56876 0.322891 6.72067 0.332251C7.87258 0.341612 9.0024 0.649291 10 1.22529ZM9.138 5.19396C9.0232 5.07918 8.87047 5.01022 8.70845 5.00003C8.54644 4.98985 8.38627 5.03913 8.258 5.13863L8.19533 5.19396L6 7.38863L5.138 6.52729L5.07533 6.47196C4.94706 6.37253 4.78691 6.32331 4.62494 6.33353C4.46296 6.34375 4.31027 6.4127 4.19551 6.52747C4.08074 6.64223 4.01179 6.79492 4.00157 6.9569C3.99135 7.11887 4.04057 7.27902 4.14 7.40729L4.19533 7.46996L5.52867 8.80329L5.59133 8.85863C5.70825 8.94934 5.85202 8.99857 6 8.99857C6.14798 8.99857 6.29175 8.94934 6.40867 8.85863L6.47133 8.80329L9.138 6.13663L9.19333 6.07396C9.29283 5.94569 9.34211 5.78552 9.33193 5.62351C9.32174 5.46149 9.25278 5.30876 9.138 5.19396Z",
    fill: "#C5DEA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.90a3be06e60ab38470e8dc85a3125841.svg";
export { ForwardRef as ReactComponent };